<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="px-3 row d-flex mt-2">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Categoria <span style="color: red; font-weight: bold;">*</span></label>
                <select class="form-control" id="position_id" v-model="data_detail.categorie_id" @change="fetchSubcategories">
                    <option value="" disabled>Seleccione</option>
                    <option v-for="(item, index) in subCa" :key="index" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label for="birthday" class="mb-1">Subcategoría <span style="color: red; font-weight: bold;">*</span></label>
                <select class="form-control" id="position_id" v-model="data_detail.subategory_id">
                    <option value="" disabled>Seleccione</option>
                    <option v-for="(item, index) in dataSubSub" :key="index" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>

            <div class="px-3 row d-flex mt-2">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="birthday" class="mb-1">Nombre <span style="color: red; font-weight: bold;">*</span></label>
                    <textarea class="form-control" id="name" placeholder="Nombre" v-model="data_detail.name" rows="1"></textarea>
                </div>
            </div>
        </div>

<!--         <div class="px-3 row d-flex mt-2">
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Cod. de Barras <span style="color: red; font-weight: bold;">*</span></label>
                <input type="text" class="form-control" id="name" placeholder="Cod. de Barras" maxlength="9" v-model="data_detail.barcode"/>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Marca <span style="color: red; font-weight: bold;">*</span></label>
                <input type="text" class="form-control" id="name" placeholder="Marca"  v-model="data_detail.brand"/>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <label for="birthday" class="mb-1">Modelo <span style="color: red; font-weight: bold;">*</span></label>
                <input type="text" class="form-control" id="name" placeholder="Modelo"  v-model="data_detail.model"/>
            </div>
        </div> -->

       <!--  <div class="px-3 row d-flex mt-2">
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Serie</label>
                <input type="text" class="form-control" id="name" placeholder="Serie"  v-model="data_detail.serie"/>
            </div>

            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Stock</label>
                <input type="text" class="form-control" id="name" placeholder="Stock"  v-model="data_detail.stock"  @keypress="isSoloNumber($event)" disabled/>
            </div>

            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Monto de Dep.</label>
                <input type="text" class="form-control" id="name" placeholder="Monto de Dep."  v-model="data_detail.depreciation_amount" @keypress="isNumber($event)"/>
            </div>

            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                <label for="birthday" class="mb-1">Tiempo de Dep.</label>
                <input type="text" class="form-control" id="name" placeholder="Tiempo de Dep."  v-model="data_detail.depreciation_time" @keypress="isNumber($event)"/>
            </div>
        </div> -->

       <div class="col-md-12 mt-3 pt-1" v-if="num === 1">
            <div class="form-check form-switch">
                <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked"
                    v-model="data_detail.state"
                    :checked="data_detail.state == 1 ? true : false"
                    aria-checked="false"
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                    {{ data_detail.state == 1 ? 'Activo' : 'Inactivo' }}
                </label>
            </div>
        </div>

        <template #footer>
            <button class="btn btn-success btn-sm" @click="DataDetail" :disabled="cpButton">
                {{ (num == 0 ) ? 'Registrar':'Editar' }}
            </button>
            &nbsp;
        </template>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from "vuex";

export default {
    name: "c-maintenance-modal-activos",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            data_detail: {
                categorie_id: '',
                subategory_id: '',
               /*  brand: '',
                model: '', */
                name: '',
                /* stock: '',
                depreciation_amount: '',
                depreciation_time: '',
                barcode: '',
                serie: '',
                technical_sheet: '', */
                state: '',
            },
            //Select
            selectedCategory: null,
            dataSubSub: [],
        };
    },
    watch: {
        payload: {
            handler(newVal) {
                if(this.num == 1){
                    if (newVal) {
                    this.data_detail = {
                        ...newVal
                    };
                    this.fetchSubcategoriesEdit();
                }
                }
            },
            immediate: true,
        },
    },
    props: {
        title: String,
        boo_modal: Boolean,
        num: Number,
        payload: {
            type: Object,
            default: null
        },
        subCa: {
            type: Array,
            default: () => []
        },
    },
    computed: {
        cpButton() {
            return !(
                this.data_detail.categorie_id !== '' &&
                this.data_detail.subategory_id !== '' &&
                this.data_detail.name.trim() !== '' 
/*                 &&
                this.data_detail.brand.trim() !== '' &&
                this.data_detail.model.trim() !== '' &&
                this.data_detail.barcode.length == 9 */
            );
        },
        filteredSubCategories() {
            if (this.selectedCategory) {
                const selectedCategory = this.subCa.find(category => category.id === this.selectedCategory);
                return selectedCategory ? selectedCategory.subcategorie || [] : [];
            }
            return [];
        }
    },
    methods: {
        ...mapActions(["get", "post"]),
        
        mtdClose() {
            this.clear();
            this.$emit("closeModal");
        },

        isNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        isSoloNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            // Permitir solo números y evitar caracteres no numéricos
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        clear(){
           /*  let fileInput = this.$refs.fileInput;
            fileInput.value = ''; */
            this.data_detail = {
                categorie_id: '',
                subategory_id: '',
         /*        brand: '',
                model: '', */
                name: '',
/*                 stock: '',
                depreciation_amount: '',
                depreciation_time: '',
                barcode: '',
                serie: '',
                technical_sheet: '', */
                state: '',
            }
        },

        DataDetail() {
            this.$emit('Datadetail', this.data_detail, this.num)
            this.mtdClose();
        },

        getFile(e) {
            let fileInput = this.$refs.fileInput;
            let file = e.target.files[0];
            if (!/\.(pdf)$/i.test(file.name)) {
                this.$refs.SweetAlert.showInfo("Seleccione un archivo formato PDF");
                fileInput.value = '';
                this.data_detail.technical_sheet = '';
            } else {
                this.data_detail.technical_sheet = file;
            }
        },

        fetchSubcategories() {
            let categoryId = this.data_detail.categorie_id;
            let selectedCategory = this.subCa.find(item => item.id === categoryId);
            if (selectedCategory) {
                this.dataSubSub = selectedCategory.subcategorie;
                this.data_detail.subategory_id = '';
            } else {
                this.dataSubSub = [];
                this.data_detail.subategory_id = '';
            }
        },

        fetchSubcategoriesEdit() {
            let categoryId = this.data_detail.categorie_id;
            let selectedCategory = this.subCa.find(item => item.id === categoryId);
            if (selectedCategory) {
                this.dataSubSub = selectedCategory.subcategorie;
            } else {
                this.dataSubSub = [];
                this.data_detail.subategory_id = '';
            }
        },

    },
    

};
</script>
